import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { RectShape, TextRow } from 'react-placeholder/lib/placeholders';
const CustomProductListItemPlaceholder = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="aspect-square"><RectShape style={{
        width: "100%",
        height: "100%"
      }} className="placeholder-loader" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TextRow className="placeholder-loader" color="inherit" style={{
      width: "50%",
      height: "20px"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative flex flex-col">{t0}{t1}<TextRow className="placeholder-loader" color="inherit" style={{
        width: "20%",
        height: "15px"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default CustomProductListItemPlaceholder;